import { RootState } from '../reducers';

export const isLoading = (state: RootState, actionType: string, defaultValue = false): boolean => {
  const loading = state.loading[actionType];

  return (loading === undefined && defaultValue) || Boolean(loading);
};
